<template>
  <div class="knd-strooigoed">
  <VideoPart 
    v-if="data.media.video"
    :poster="undefined"
    :controls="false"
    :loop="true"
    :description="''"
    :autoplay="true"
    :src="VUE_APP_PBASE + data.media.video[0]['url']" 
  />

  <ImagePart 
    v-if="data.media.afbeelding"
    :media="data.media.afbeelding" 
    :size="data.media.size"
  />
</div>
</template>

<script>
import { toRefs, ref } from 'vue';
import VideoPart from '@/components/video';
import ImagePart from '@/components/image';

export default {
	name: 'Strooigoed',
  components: {VideoPart, ImagePart},
  props: {
    data: Object,
    question: Object,
  },
  setup(props) {
    const VUE_APP_PBASE = ref(process.env.VUE_APP_PBASE);


    return {
      VUE_APP_PBASE
    }

  },
	methods: {
	}
}
</script>


<style lang="scss">
  .knd-strooigoed {
    margin: 0 auto;
    max-width: 650px;

    .videopart__video {
      max-height: 300px;
    }
  }
  
</style>